<template>
  <RevDrawer :name="MODAL_NAMES.CONDITION" :title="i18n(translations.title)">
    <template #body>
      <div>
        <ProductConditionCard
          v-if="currentToggle === 'screen' && currentGrade === 9"
          :content="
            isNewDescriptionActive
              ? i18n(gradePScreen.contentNew)
              : i18n(gradePScreen.content)
          "
          :grade="9"
          :imageSrc="getGradeImage(9, 'Screen')"
          :pills="[
            {
              icon: IconOfficialFilled,
              text: i18n(gradePScreen.pill1, { brand }),
            },
          ]"
          :show-as-card="false"
          :title="i18n(gradePScreen.grade)"
          :titleIcon="IconDiamond"
        />
        <ProductConditionCard
          v-if="currentToggle === 'screen' && currentGrade === 10"
          :content="
            isNewDescriptionActive
              ? i18n(gradeAScreen.contentNew)
              : i18n(gradeAScreen.content)
          "
          :grade="10"
          :imageSrc="getGradeImage(10, 'Screen')"
          :pills="[
            {
              icon: IconCheckInCircle,
              text: i18n(gradeAScreen.pill1),
            },
          ]"
          :show-as-card="false"
          :title="i18n(gradeAScreen.grade)"
        />
        <ProductConditionCard
          v-if="currentToggle === 'screen' && currentGrade === 11"
          :content="
            isNewDescriptionActive
              ? i18n(gradeBScreen.contentNew)
              : i18n(gradeBScreen.content)
          "
          :grade="11"
          :imageSrc="getGradeImage(11, 'Screen')"
          :pills="[
            {
              icon: IconCheckInCircle,
              text: i18n(gradeBScreen.pill1),
            },
          ]"
          :show-as-card="false"
          :title="i18n(gradeBScreen.grade)"
        />
        <ProductConditionCard
          v-if="currentToggle === 'screen' && currentGrade === 12"
          :content="
            isNewDescriptionActive
              ? i18n(gradeCScreen.contentNew)
              : i18n(gradeCScreen.content)
          "
          :grade="12"
          :imageSrc="getGradeImage(12, 'Screen')"
          :pills="[
            {
              icon: IconCheckInCircle,
              text: i18n(gradeCScreen.pill1),
            },
          ]"
          :show-as-card="false"
          :title="i18n(gradeCScreen.grade)"
        />

        <ProductConditionCard
          v-if="currentToggle === 'body' && currentGrade === 9"
          :content="
            isNewDescriptionActive
              ? i18n(gradePBody.contentNew)
              : i18n(gradePBody.content)
          "
          :grade="9"
          :imageSrc="getGradeImage(9, 'Body')"
          :pills="[
            {
              icon: IconSparkles,
              text: i18n(gradePBody.pill1),
            },
            {
              icon: IconOfficialFilled,
              text: i18n(gradePBody.pill2, { brand }),
            },
            {
              icon: IconBattery,
              text: isNewDescriptionActive
                ? i18n(gradePBody.pill3New)
                : i18n(gradePBody.pill3),
            },
          ]"
          :show-as-card="false"
          :title="i18n(gradePBody.grade)"
          :titleIcon="IconDiamond"
        />
        <ProductConditionCard
          v-if="currentToggle === 'body' && currentGrade === 10"
          :content="
            isNewDescriptionActive
              ? i18n(gradeABody.contentNew)
              : i18n(gradeABody.content)
          "
          :grade="10"
          :imageSrc="getGradeImage(10, 'Body')"
          :pills="[
            {
              icon: IconCheckInCircle,
              text: i18n(gradeABody.pill1),
            },
            {
              icon: IconBattery,
              text: isNewDescriptionActive
                ? i18n(gradeABody.pill2New)
                : i18n(gradeABody.pill2),
            },
          ]"
          :show-as-card="false"
          :title="i18n(gradeABody.grade)"
        />
        <ProductConditionCard
          v-if="currentToggle === 'body' && currentGrade === 11"
          :content="
            isNewDescriptionActive
              ? i18n(gradeBBody.contentNew)
              : i18n(gradeBBody.content)
          "
          :grade="11"
          :imageSrc="getGradeImage(11, 'Body')"
          :pills="[
            {
              icon: IconCheckInCircle,
              text: i18n(gradeBBody.pill1),
            },
            {
              icon: IconBattery,
              text: isNewDescriptionActive
                ? i18n(gradeBBody.pill2New)
                : i18n(gradeBBody.pill2),
            },
          ]"
          :show-as-card="false"
          :title="i18n(gradeBBody.grade)"
        />
        <ProductConditionCard
          v-if="currentToggle === 'body' && currentGrade === 12"
          :content="
            isNewDescriptionActive
              ? i18n(gradeCBody.contentNew)
              : i18n(gradeCBody.content)
          "
          :grade="12"
          :imageSrc="getGradeImage(12, 'Body')"
          :pills="[
            {
              icon: IconCheckInCircle,
              text: i18n(gradeCBody.pill1),
            },
            {
              icon: IconBattery,
              text: isNewDescriptionActive
                ? i18n(gradeCBody.pill2New)
                : i18n(gradeCBody.pill2),
            },
          ]"
          :show-as-card="false"
          :title="i18n(gradeCBody.grade)"
        />
      </div>

      <ul class="mt-24 grid list-none grid-cols-2 gap-12">
        <StepOption
          v-for="(option, index) in [...step.options].reverse()"
          :key="option.trackingValue"
          :index
          is-small
          :option="{
            ...option,
            tag: null,
            selected: currentGrade === parseInt(option.trackingValue ?? '', 10),
          }"
          :should-trigger-navigation="false"
          :step
          @click="() => onGradeClick(parseInt(option.trackingValue ?? '', 10))"
        />
      </ul>

      <h2 class="heading-2 mt-24">{{ i18n(translations.title) }}</h2>
      <p class="body-1 mt-12">{{ i18n(translations.about) }}</p>

      <div v-if="hasScreenAndBody" class="sticky bottom-0 left-0 right-0 pb-24">
        <ProductConditionSwitcher v-model="currentToggle" class="shadow-long" />
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { IconBattery } from '@ds/icons/IconBattery'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'
import { IconDiamond } from '@ds/icons/IconDiamond'
import { IconOfficialFilled } from '@ds/icons/IconOfficialFilled'
import { IconSparkles } from '@ds/icons/IconSparkles'

import { MODAL_NAMES } from '../../Product-JP.constants'
import { getGradeImage as getGradeImageBase } from '../../utils/getGradeImage'
import StepOption from '../CustomizationFunnel/components/StepOption/StepOption.vue'
import type { Step } from '../CustomizationFunnel/utils/types'
import gradeABody from '../ProductConditionBlock/components/ProductConditionBody/gradeA.translations'
import gradeBBody from '../ProductConditionBlock/components/ProductConditionBody/gradeB.translations'
import gradeCBody from '../ProductConditionBlock/components/ProductConditionBody/gradeC.translations'
import gradePBody from '../ProductConditionBlock/components/ProductConditionBody/premium.translations'
import ProductConditionCard from '../ProductConditionBlock/components/ProductConditionCard/ProductConditionCard.vue'
import type { SwitcherValue } from '../ProductConditionBlock/components/ProductConditionCard/components/ProductConditionSwitcher/ProductConditionSwitcher.types'
import ProductConditionSwitcher from '../ProductConditionBlock/components/ProductConditionCard/components/ProductConditionSwitcher/ProductConditionSwitcher.vue'
import gradeAScreen from '../ProductConditionBlock/components/ProductConditionScreen/gradeA.translations'
import gradeBScreen from '../ProductConditionBlock/components/ProductConditionScreen/gradeB.translations'
import gradeCScreen from '../ProductConditionBlock/components/ProductConditionScreen/gradeC.translations'
import gradePScreen from '../ProductConditionBlock/components/ProductConditionScreen/premium.translations'

import translations from './ConditionModal.translations'

const props = defineProps<{ step: Step; brand: string }>()

const i18n = useI18n()

const currentGrade = ref(10)
const currentToggle = ref<SwitcherValue>('body')

const experiments = useExperiments()
const isNewDescriptionActive =
  experiments['experiment.ppJapanNewDescription'] === 'withNewDescription'

function getGradeImage(gradeId: number, type: 'Screen' | 'Body') {
  return getGradeImageBase(props.step, gradeId, type)
}

function onGradeClick(gradeId: number) {
  currentGrade.value = gradeId
}

const hasScreenAndBody = computed(() => !!getGradeImage(10, 'Screen'))
</script>
